module.exports = __webpack_public_path__ + "static/media/sobre-nosotros.17bd41f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/sobre-nosotros.jpg
// module id = 91
// module chunks = 0